import { gql } from '@apollo/client';

export const endOrCancelReservationMutation = gql`
  mutation EndOrCancelReservationMutation($reservationId: ID!) {
    endOrCancelReservation(reservationId: $reservationId) {
      reservationId
    }
  }
`;
